import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { partnerMaterialKeys } from '@/api/query-keys';
import {
  listPartnerMaterialsContract,
  type ListPartnerMaterialsResponse,
  type PartnerMaterial
} from '@bliks-io/contracts';

/** The active materials a partner can use. */

export function usePartnerMaterials() {
  return useQuery({
    queryKey: partnerMaterialKeys.partner(),
    queryFn: async ({ signal }): Promise<PartnerMaterial[]> => {
      const { data } = await apiClient.get<ListPartnerMaterialsResponse>(
        listPartnerMaterialsContract.path,
        { signal }
      );
      return data.data;
    }
  });
}
